import React, { createContext, useContext, useEffect, useState } from "react"

const isRemountedContext = createContext<boolean>(false)
const setIsRemountedContext = createContext<
  React.Dispatch<React.SetStateAction<boolean>>
>(() => {})
const isRefreshingContext = createContext<boolean>(true)
const setIsRefreshingContext = createContext<
  React.Dispatch<React.SetStateAction<boolean>>
>(() => {})

interface Props {
  children: React.ReactNode
}

export function RefreshPlayerProvider({ children }: Props) {
  const [isRemounted, setIsRemounted] = useState<boolean>(false)
  const [isRefreshing, setIsRefreshing] = useState<boolean>(true)

  useEffect(() => {
    if (!isRemounted) return
    setIsRefreshing(true)

    setTimeout(() => {
      setIsRemounted(false)
    }, 500)
  }, [isRemounted])

  return (
    <isRemountedContext.Provider value={isRemounted}>
      <setIsRemountedContext.Provider value={setIsRemounted}>
        <isRefreshingContext.Provider value={isRefreshing}>
          <setIsRefreshingContext.Provider value={setIsRefreshing}>
            {children}
          </setIsRefreshingContext.Provider>
        </isRefreshingContext.Provider>
      </setIsRemountedContext.Provider>
    </isRemountedContext.Provider>
  )
}

export function usePlayerRefreshIsRemounted() {
  return useContext(isRemountedContext)
}

export function useSetPlayerRefreshIsRemounted() {
  return useContext(setIsRemountedContext)
}

export function usePlayerIsRefreshing() {
  return useContext(isRefreshingContext)
}

export function useSetPlayerIsRefreshing() {
  return useContext(setIsRefreshingContext)
}
